export const blankState = `w-full h-full bg-ll-surface py-6 px-5 rounded-md text-ll-placeholder`;
